module.exports = __webpack_public_path__ + "img/bg14.9bd6761a.png";